import { createEmotionCache, EmotionCacheProvider } from './ds/components/ssr'
import Root from './src/components/Root'

/**
 * Wrap the root element with EmotionCacheProvider for hydration consistency.
 * This must match the SSR wrapper to prevent hydration mismatches and CLS.
 *
 * We create a new cache for each render to match SSR behavior.
 */
export const wrapRootElement = ({ element }) => {
    // Create cache inside the render function to match SSR behavior
    const cache = createEmotionCache()

    return (
        <EmotionCacheProvider cache={cache}>
            <Root>{element}</Root>
        </EmotionCacheProvider>
    )
}

/**
 * Unregister any existing service workers.
 *
 * The main protection (freezing ___swUpdated) is now in html.js which runs
 * before any Gatsby JS. This hook just cleans up any stray service workers.
 */
export const onClientEntry = () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            for (const registration of registrations) {
                registration.unregister()
            }
        })
    }
}

/**
 * Prevent service worker updates from triggering page reloads.
 * These callbacks override Gatsby's default behavior which would set
 * window.___swUpdated = true and cause a full page reload.
 */
export const onServiceWorkerUpdateReady = () => {
    // Don't reload - preserve document.referrer
}

export const onServiceWorkerUpdateFound = () => {
    // No action needed
}

export const onServiceWorkerInstalled = () => {
    // No action needed
}

export const onServiceWorkerActive = () => {
    // No action needed
}

export const onServiceWorkerRedundant = () => {
    // No action needed
}
